import families from '@/services/api/families';
import upload from '@/services/api/upload';

export default {
    namespaced: true,
    state: {
        familiesToAccept: [],
        consentURI: [],
        familiesAmount: 0,
        consentLink: null
    },
    getters: {
        getFamiliesToAccept (state) {
            return state.familiesToAccept;
        },
        getConsentURI (state) {
            return state.consentURI;
        },
        getFamiliesAmount (state) {
            return state.familiesAmount;
        },
        getConsentLink: (state) => state.consentLink
    },
    mutations: {
        setFamiliesToAccept (state, payload) {
            state.familiesToAccept = payload;
        },
        setConsentURI (state, data) {
            state.consentURI = data;
        },
        setFamiliesAmount (state, payload) {
            state.familiesAmount = payload;
        },
        setConsentLink (state, data) {
            state.consentLink = data;
        }
    },
    actions: {
        getFamiliesToAccept (context, payload) {
            return families.getFamiliesToAccept(payload).then(({ data }) => {
                context.commit('setFamiliesToAccept', data.data);
                context.commit('setFamiliesAmount', data.amount);
            });
        },
        removeFamilyToAccept (context, id) {
            return families.deleteFamilyToAccept(id);
        },
        convertFamilyToAccept (context, id) {
            return families.convertFamilyToAccept(id);
        },
        postConsent (context, data) {
            return upload.uploadFiles(data);
        },
        postFamilyToAccept (context, data) {
            return families.postFamilyToAccept(data);
        },
        clearData (context) {
            context.commit('setFamiliesToAccept', []);
            context.commit('setConsentURI', []);
        },
        getFamilyToAcceptConsentUri (context, data) {
            context.commit('setConsentLink', upload.getFamilyToAcceptConsentUri(data));
        },
        verifiedConsent (context, id) {
            return families.verifiedConsent(id);
        }
    }
};
